export default __webpack_public_path__ + "static/media/Ncash-small.65aba11f.png";